import React from "react";
import ModuleNavigation from "../ModuleNavigation";

export default function StockModule() {
  return <ModuleNavigation moduleId="StockModule" />;
}
